import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage
import authentication from './authentication'
import dashboard from './dashboard'
import portfolioLibrary from './portfolioLibrary'
import portfolioDetails from './portfolioDetails'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import libraryOfFundsReducer from './libraryOfFunds'
import createPortfolio from './createPortfolio'
import portfolioTracking from './portfolioTracking'

const rootReducer = combineReducers({
    authentication,
    dashboard,
    portfolioLibrary,
    portfolioDetails,
    libraryOfFundsReducer,
    createPortfolio,
    portfolioTracking
})

const persistedReducer = persistReducer(
    {
        key: 'root',
        storage,
        whitelist: ['authentication']
    },
    rootReducer
)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            thunkMiddleware: thunkMiddleware
        })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const persistor = persistStore(store)
